import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Message } from "element-ui";
import permissionIndividuation from "@/permission";
import auth from "_private/auth";
import store from "_private/store";

let permissionPrivate = function(router) {
  const LOGIN = "/login";
  // 路由守卫
  router.beforeEach((to, from, next) => {
    let moduleId = to.meta.moduleId ? to.meta.moduleId : 0;
    const newRouter = [
      "/boardAlarmIndex",
      "/gdColdBoard",
      "/boardStorageAnalysis",
      "/storageMonitor",
      "/vehicleOfflineReport",
      "/monitCenterComparyList",
      "/monitCenterVehicleList",
      "/monitCenterVehicleTrackList",
      "/monitCenterStorageList",
      "/monitCenterStoreList"
    ];
    store.commit("SET_MODULE_ID", moduleId);
    NProgress.start();
    // if (to.meta && to.meta.title) {
    //   console.log(document.title, to.meta.title);
    //   document.title = to.meta.title;
    // }

    console.log(newRouter.some(route => route === to.path));

    if (from.path === "/home") {
      if (to.path === "/login") {
        NProgress.done();
        next();
        return false;
      }
      // console.log(to.path);
      // if (to.path === "/gdColdBoard" || to.path === "/gdColdBoard") {
      //   let routerUrl = router.resolve({
      //     path: to.path,
      //     query: to.query
      //   });
      //   document.title = from.meta.title;
      //   window.open(routerUrl.href, "_blank");
      //   NProgress.done();
      //   next(false);
      // }

      // next();
      // return false;
    }
    console.log(to.path);
    const newWindow = newRouter.some(route => route === to.path);

    // if (newWindow) {
    //   let routerUrl = router.resolve({
    //     path: to.path,
    //     query: to.query
    //   });
    //   document.title = to.meta.title;
    //   console.log(routerUrl.href);
    //   window.open(routerUrl.href, "_blank");
    //   NProgress.done();
    //   next(false);
    //   return false;
    // }
    if (newWindow && from.path !== "/") {
      let routerUrl = router.resolve({
        path: to.path
      });
      window.open(routerUrl.href, "_blank");
      NProgress.done();
      next(false);
      return false;
    }
    if (to.meta.auth == false) {
      next();
    } else {
      if (!auth.isAuthenticated()) {
        next(LOGIN);
        NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
      } else {
        store.dispatch("setUserInfoAct", auth.getUserInfo()); // 防止刷新页面用户信息丢失
        if (store.getters.addRouters.length) {
          next();
        } else {
          store
            .dispatch("generateRouterAct")
            .then(response => {
              if (response.code === 1) {
                store
                  .dispatch("generateMenuAct")
                  .then(menuResponse => {
                    if (menuResponse.code === 1) {
                      let routes = [...store.getters.addRouters];
                      router.addRoutes(routes); // 动态添加路由列表
                      next({
                        ...to,
                        replace: true
                      });
                    } else {
                      throw {
                        message: menuResponse.message
                      };
                    }
                  })
                  .catch(error => {
                    Message({
                      message: error.message || "获取菜单错误！",
                      type: "error",
                      duration: 2 * 1000
                    });
                    next(LOGIN);
                  });
              } else {
                throw {
                  message: response.message
                };
              }
            })
            .catch(error => {
              Message({
                message: error.message || "获取路由错误！",
                type: "error",
                duration: 2 * 1000
              });
              next(LOGIN);
            });
        }
      }
    }
  });

  router.afterEach(to => {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    }
    NProgress.done();
  });
};
let permission =
  typeof permissionIndividuation.handle === "function"
    ? permissionIndividuation.handle
    : permissionPrivate;

export default permission;
